export default {
  defailt: {
    title: 'Your journey can become smoother',
    subTitle: 'Faster checkout, booking history, and special promotions just for you',
    alreadyHave: 'Already have an account?',
    logIn: 'Connectez-vous',
    joinUs: 'Nous joindre',
    btnSignUp: 'Se connecter par courriel',
  },
  signIn: {
    title: 'Bon retour!',
    subTitle: 'Connectez-vous dans votre compte et continuez votre voyage',
    btnSignIn: 'Sign in',
    serverMessage: 'Votre courriel ou mot de passe est incorrect',
    form: {
      fields: {
        email: {
          label: 'Courriel',
          required: 'Votre courriel',
        },
        password: {
          label: 'Mot de passe',
          required: 'Votre mot de passe',
        },
      },
    },
  },
  signUp: {
    title: 'S\'incrire avec votre courriel',
    btnGoogle: 'Continuer avec Google',
    separateOr: 'OU',
    btnSignUp: 'S\'incrire avec son courriel',
    serverMessages: {
      exist: 'Un utilisateur avec ce courriel existe déjà',
    },
    form: {
      fields: {
        firstName: {
          label: 'Prénom',
          required: 'Prénom est requis',
        },
        lastName: {
          label: 'Nom',
          required: 'Nom est requis',
        },
        phone: {
          label: 'Téléphone',
        },
        email: {
          label: 'Courriel',
          required: 'Courriel est requis',
        },
        password: {
          label: 'Mot de passe',
          required: 'Mot de passe est requis',
        },
      },
    },
  },
  footer: {
    text: 'En créant votre compte vous acceptez',
    termsOfUse: ' Termes d\'utilisation ',
    and: 'et',
    privacyPolicy: 'Politique de confidentialité',
  },
};
